import { useQuery } from "@tanstack/react-query";
import { getFaqs } from "../requests/faq";

export const useFaqs = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["faq"],
    queryFn: () => getFaqs(),
  })

  return {
    data,
    isLoading,
  }
}